import api from './api';

// CRUD dos Perfis ERP (dbo.ImportacoesTitulosApisErps).
// Cada perfil descreve UM ERP (Bluesoft v1, Omie v1, etc.) com URL base, endpoints
// e tipo de autenticacao. Ancoras se vinculam a esses perfis via
// AncorasImportacoesTitulosApisErps (tela em pages/Anchors/ImportacoesTitulos).

export async function consultar({
  paginaInicial = 1,
  itensPorPagina = 50,
  status = '',
  erp = '',
  versao = '',
} = {}) {
  const qs = new URLSearchParams();
  qs.append('paginaInicial', paginaInicial);
  qs.append('itensPorPagina', itensPorPagina);
  if (status) qs.append('status', status);
  if (erp) qs.append('erp', erp);
  if (versao) qs.append('versao', versao);
  return api.get(`ImportacoesTitulosApisErps/Consultar?${qs.toString()}`);
}

export async function consultarId(id) {
  return api.get(`ImportacoesTitulosApisErps/ConsultarId?id=${id}`);
}

export async function adicionar(payload) {
  return api.post('ImportacoesTitulosApisErps', payload);
}

export async function atualizar(payload) {
  return api.put('ImportacoesTitulosApisErps', payload);
}

export async function apagar(id) {
  return api.delete(`ImportacoesTitulosApisErps/${id}`);
}

// Enum backend enumImportacaoTituloApiErpTipoAutenticacao (JsonStringEnumConverter -> string no JSON)
export const TIPOS_AUTENTICACAO = [
  { value: 'OAuth2ClientCredentials', label: 'OAuth2 Client Credentials' },
];
